import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

export default function TimeComponent({ onChange = (_time) => { } }) {
    const now = new Date();

    const [hours, setHours] = useState(now.getHours());
    const [minutes, setMinutes] = useState(now.getMinutes());

    const hourOptions = Array.from({ length: 24 }, (_, i) => ({
        label: String(i).padStart(2, "0"),
        value: i,
    }));

    const minuteOptions = Array.from({ length: 60 }, (_, i) => ({
        label: String(i).padStart(2, "0"),
        value: i,
    }));

    useEffect(() => {
        var r = setTimeout(() => {
            onChange(
                `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
            );
        }, 200);
        return () => {
            clearTimeout(r)
        }
    }, [hours, minutes]);


    return (
        <div style={{ display: "flex", alignItems: "center" }} className="flex items-center gap-2 w-full">
            {/* Hours dropdown */}
            <Dropdown
                value={hours}
                options={hourOptions}
                onChange={(e) => setHours(e.value)}
                className="w-full"
                panelClassName="font-mono"
            />

            <span className="text-2xl font-mono">:</span>

            {/* Minutes dropdown */}
            <Dropdown
                value={minutes}
                options={minuteOptions}
                onChange={(e) => setMinutes(e.value)}
                className="w-full"
                panelClassName="font-mono"
            />
        </div>
    );
}
